import { escape } from "html-escaper";

export default function (value: string): string {
  if (!value) {
    return "";
  }
  return escape(value);
}
